/**
 * FILTER-CREATE-MERGED
 * Create a new filter population by merging selected populations
 */

import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"
import { SurveyState } from "@/redux/survey.types"
import { store } from "@/core/root-reducer"
import { filterCreateMerged_AsSupervisor, filterStatus } from "@/redux/filter.actions"
import { STATUS_SAVED, STATUS_SAVE_ERROR, STATUS_SAVING } from "@/redux/_status.types"
import Modal from "@/components/modal"
import { useState } from "react"
import TextInput from "@/components/text-input"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { t } from "i18next"

interface StateProps {
  _session: Session
  survey: SurveyState
}

interface OwnProps {
  onClose: Function
  onDone: Function
  attributeIds: number[]
  populationNames: string[]
}

type Props = StateProps & OwnProps

function FilterCreateMergedModal(props: Props) {
  const navigate = useNavigate()
  const [filterName, setFilterName] = useState<string>("")
  const [populationName, setPopulationName] = useState<string>("")

  function confirm() {
    if (!filterName.trim() || !populationName.trim()) return

    store.dispatch(filterStatus(STATUS_SAVING))

    const response: any = store.dispatch(
      filterCreateMerged_AsSupervisor(
        filterName.trim(),
        populationName.trim(),
        props.attributeIds,
        props.survey.active.id
      )
    )

    if (response.error) {
      store.dispatch(filterStatus(STATUS_SAVE_ERROR))
      toast(t(response.error), { type: "error" })
    } else {
      store.dispatch(filterStatus(STATUS_SAVED))
      props.onDone()
      props.onClose()
      navigate("/dashboard/home")
    }
  }

  const isValid = filterName.trim().length > 0 && populationName.trim().length > 0

  return (
    <Modal
      isCloseButtonVisible
      onClose={() => props.onClose()}
      onNext={isValid ? () => confirm() : undefined}
      title="Créer un nouveau filtre à partir de populations existantes">
      <p>{"Créer un nouveau filtre à partir des populations sélectionnées :"}</p>

      <ul>
        {props.populationNames.map((name, i) => (
          <li key={i}>
            <b>{name}</b>
          </li>
        ))}
      </ul>

      <div className="flex" style={{ gap: 16, marginTop: 16 }}>
        <TextInput
          onChange={(e) => setFilterName(e.value)}
          placeholder="Nom du filtre"
          title="Nom du filtre"
          value={filterName}
        />

        <TextInput
          onChange={(e) => setPopulationName(e.value)}
          placeholder="Nom de la population"
          title="Nom de la population"
          value={populationName}
        />
      </div>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  survey: state.survey
})

export default connect(mapStateToProps)(FilterCreateMergedModal)
